import { render, staticRenderFns } from "./DashboardSessionStats.vue?vue&type=template&id=8adaa7f8&scoped=true&"
import script from "./DashboardSessionStats.vue?vue&type=script&lang=js&"
export * from "./DashboardSessionStats.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSessionStats.vue?vue&type=style&index=0&id=8adaa7f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adaa7f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VCard,VCardText,VCardTitle,VDivider,VImg})
